/** Reads the first connected gamepad. The one place the input layer touches `navigator`. */

import type { PadState } from './gamepadMap';

/** Analogue triggers count as pressed from here, for browsers that never set `pressed` on them. */
const TRIGGER_THRESHOLD = 0.35;

/**
 * The first connected standard-mapping pad's axes and buttons, or null. Anything else - a wheel,
 * a throttle, pedals - has axes that rest anywhere and buttons in any order, and `readPad` would
 * read it as a ranger walking into a wall. `getGamepads` is missing in some embedded browsers and
 * throws where a permissions policy forbids it: both mean "no pad".
 */
export function pollPad(): PadState | null {
  try {
    if (typeof navigator === 'undefined' || typeof navigator.getGamepads !== 'function') return null;
    for (const pad of navigator.getGamepads()) {
      if (pad === null || !pad.connected || pad.mapping !== 'standard') continue;
      return {
        axes: Array.from(pad.axes),
        buttons: pad.buttons.map((b) => b.pressed || b.value > TRIGGER_THRESHOLD),
      };
    }
  } catch {
    // Falls through: no pad.
  }
  return null;
}
